import React from 'react'
import { Alert, Snackbar } from '@mui/material'

interface DomainWarningSnackbarProps {
  open: boolean
  onClose: () => void
}

export const DomainWarningSnackbar: React.FC<DomainWarningSnackbarProps> = ({ open, onClose }) => (
  <Snackbar
    open={open}
    autoHideDuration={null}
    onClose={(_, reason) => {
      if (reason) return
      onClose()
    }}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <Alert severity="warning" sx={{ width: '100%', textAlign: 'left', justifyContent: 'flex-start' }} onClose={onClose}>
      It looks like you used a personal email. Please sign in with your school-issued email to avoid login issues.
    </Alert>
  </Snackbar>
)
